import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';

export const UPDATE_LOADING_STATUS = 'FETCH_MENU_SUCCESS';
export const FETCH_APPMANGE_DATA_LIST = 'FETCH_APPMANGE_DATA_LIST';

/**
 * 修改页面加载loading
 * @param {*} param
 */
export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

/**
 * 获取APP灰度数据列表
 * @param {*} param
 */
export function fetchAppMangeList(param) {
  return (dispatch, getState) => {
    const defaultParam = {}
    const req = Object.assign({}, defaultParam, param);
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/gray/config/page`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      dispatch(updateLoadingStatus(false));
      if (res.code == 200) {
        dispatch({
          type: FETCH_APPMANGE_DATA_LIST,
          dataList: res.data || [],
          dataListTotal: res.page.total,
        });
      } else {
        message.error(intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      dispatch(updateLoadingStatus(false));
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 新增角色
 * @param {*} param
 */
export function addGray(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('POST', param, callback, failback)
  };
}

/**
 * 修改角色
 * @param {*} param
 */
export function editGray(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('PUT', param, callback, failback)
  };
}

/**
 * 删除角色
 * @param {*} param
 */
export function deleteGray(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('DELETE', param, callback, failback)
  };
}

/**
 * 封装接口函数
 * @param {*} param
 */
function fetchFun(method, param, callback, failback) {
  const defaultParam = {}
  const req = Object.assign({}, defaultParam, param);
  const fetchData = new FetchData(`${util.requestPath}/api/iot/support/gray/config`, {
    method: method,
    body: req,
  });
  fetchData.then((res) => {
    if (res.code == 200) {
      message.success(intl.get('commmon.operate.success'));
      callback && callback(true);
    } else if (res.code == 70101) {
      callback && callback(false);
    } else {
      failback && failback();
      message.error(intl.get('commmon.operate.retry'));
    }
  }).catch(e => {
    failback && failback();
    message.error(intl.get('commmon.operate.retry'));
  })
}
